<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">点位管理&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>点位事项管理</div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="biaodan2">
        <div class="biaodan-left">
          <div style="height: 100%;width: 100%;">
            <el-form
              :inline="true"
              label-position="left"
              class="demo-form-inline"
              :model="form"
            >
              <el-form-item label="点位名称">
                <el-input
                  v-model="form.pointName"
                  clearable
                  placeholder="请输入点位名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="点位类型">
                <el-select
                  filterable
                  placeholder="点位类型"
                  clearable
                  v-model="form.pointTypeNameId"
                >
                <el-option
                    v-for="item in pointTypeOptions"
                    :key="item.id"
                    :label="item.typeName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属社区">
                <el-select
                  filterable
                  placeholder="所属社区"
                  clearable
                  v-model="communityCode"
                  @change="commcommunityChange"
                >
                  <el-option
                    v-for="item in commcommunityList"
                    :key="item.deptCode"
                    :label="item.pointName"
                    :value="item.id + '-' + item.deptCode"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属网格">
                <el-select
                  filterable
                  placeholder="所属网格"
                  clearable
                  v-model="form.jqDeptCode"
                >
                  <el-option
                    v-for="item in blockList"
                    :key="item.deptCode"
                    :label="item.pointName"
                    :value="item.deptCode"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="事项类型">
                <el-select
                  filterable
                  placeholder="事项类型"
                  clearable
                  v-model="form.ghEventTypeId"
                >
                  <el-option
                    v-for="item in typeList"
                    :key="item.id"
                    :label="item.sxlx"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="事项名称">
                <el-input
                  v-model="form.sxmc"
                  clearable
                  placeholder="请输入事项名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="是否应急事项">
                <el-select
                  filterable
                  placeholder="是否应急事项"
                  clearable
                  v-model="form.sfyjsx"
                >
                  <el-option
                    v-for="item in sfyjsxOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="是否开启定时任务">
                <el-select
                  filterable
                  placeholder="是否开启定时任务"
                  clearable
                  v-model="form.state"
                >
                  <el-option
                    v-for="item in sfyjsxOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form-item">
                <el-button @click="onSearch" class="search">查询</el-button>
                <el-button class="reset" @click="onReset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="aside">
        <div class="table-top-btns">
          <div class="left-btn">
            <div class="select-number">
              当前选中
              <span style="color: #3666EA;">{{
                selectedIdOptions.length
              }}</span>
              条
            </div>
          </div>
          <div class="right-btn">
            <el-button @click="addDialogAllFun" class="search"
              >批量配置事项标准</el-button
            >
            <el-button @click="ruleDialogAllFun" class="search"
              >批量配置任务规则</el-button
            >
          </div>
        </div>
        <common-table
          :maxHeight="440"
          :select="true"
          :page="page"
          :dataList="dataList"
          :selectedIdOptions="selectedIdOptions"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
          @handleSelectionChange="handleSelectionChange"
          @selectAll="selectAll"
        >
          <template v-slot:state="{ scope }">
            <el-switch
              @change="
                value => {
                  creatAndChangeEventPointRelStateFun(value, scope.row);
                }
              "
              v-model="scope.row.state"
              active-value="是"
              inactive-value="否"
              active-color="#0495FF"
            >
            </el-switch>
          </template>
          <template v-slot:pointOtherRulueId="{ scope }">
            <span
              v-if="
                scope.row.pointOtherRulueId && scope.row.newRuleState == '是'
              "
              >自定义规则</span
            >
            <span v-else>初始化规则</span>
          </template>
          <template v-slot:operation="{ scope }">
            <el-button
              @click="addDialogFun(scope.row)"
              style="color: #0090FF;font-size: 16px;"
              type="text"
              >点位事项指标</el-button
            >
            <el-button
              @click="ruleDialogFun(scope.row)"
              style="color: #0090FF;font-size: 16px;"
              type="text"
              >自定义规则</el-button
            >
          </template>
        </common-table>
      </div>
    </div>
    <tipDialog v-if="dialogVisible" :dialogVisible.sync="dialogVisible">
    </tipDialog>
    <sxzbDrawer
      v-if="zbDialogVisible"
      :dialogVisible.sync="zbDialogVisible"
      :curItem="curItem"
      :type="type"
      :eventMangerId="eventMangerId"
      :ghPointLevelIdList="ghPointLevelIdList"
    >
    </sxzbDrawer>
    <ruleSettingDialog
      v-if="ruleDialogVisible"
      @refreshList="mangerPonitRelPageFun"
      :dialogVisible.sync="ruleDialogVisible"
      :unionIdList="unionIdList"
      :pointOtherRulueId="pointOtherRulueId"
      :eventMangerId="eventMangerId"
      :type="2"
    >
    </ruleSettingDialog>
  </div>
</template>
<script>
import {
  mangerPonitRelPage,
  selList,
  creatAndChangeEventPointRelState
} from "@/api/base.js";
import sxzbDrawer from "./components/sxzbDrawer.vue";
import tipDialog from "./components/tipDialog.vue";
import ruleSettingDialog from "@/pages/baseInfo/issuesManagement/components/ruleSettingDialog.vue";
import commonTable from "@/components/table/index.vue";
import pageChangeSelect from "@/mixins/page-change-select.js";
import index from "@/mixins/index.js";
export default {
  components: {
    sxzbDrawer,
    tipDialog,
    commonTable,
    ruleSettingDialog
  },
  mixins: [pageChangeSelect, index],
  data() {
    return {
      form: {
        pointName: "",
        pointTypeNameId: "",
        communityCode: "",
        jqDeptCode: "",
        ghEventTypeId: "",
        sxmc: "",
        state: "",
        sfyjsx: ""
      },
      sfyjsxOptions: [
        {
          label: "是",
          value: "是"
        },
        {
          label: "否",
          value: "否"
        }
      ],
      typeList: [],
      dialogVisible: false,
      zbDialogVisible: false,
      ruleDialogVisible: false,
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "pointTypeName",
            label: "点位类型"
          },
          {
            prop: "pointName",
            label: "点位名称"
          },
          {
            prop: "sq",
            label: "所属社区"
          },
          {
            prop: "jq",
            label: "所属网格"
          },

          {
            prop: "sxlx",
            label: "事项类型"
          },
          {
            prop: "sxmc",
            label: "事项名称"
          },
          {
            prop: "sfyjsx",
            label: "是否应急事项"
          },
          {
            slot: "state",
            label: "是否开启定时任务"
          },
          {
            slot: "pointOtherRulueId",
            label: "当前规则"
          },
          {
            slot: "operation",
            label: "操作",
            width: 300
          }
        ]
      },
      curItem: {},
      unionIdList: [],
      pointOtherRulueId: "",
      eventMangerId: "",
      pointLevelId: "",
      type: 1,
      ghPointLevelIdList: []
    };
  },
  mounted() {
    this.getCommcommunityAllFun();
    this.getPointTypeListPageFun();
    this.selListFun();
    this.mangerPonitRelPageFun();
  },
  methods: {
    async selListFun() {
      const res = await selList({});
      this.typeList = res.data.data || [];
    },
    openDialog() {
      this.zbDialogVisible = true;
    },
    addDialogFun(item) {
      this.type = 1;
      this.zbDialogVisible = true;
      this.curItem = item;
    },
    addDialogAllFun() {
      this.type = 2;
      if (!this.selectedOptions.length) {
        this.$message({
          type: "error",
          message: "请先选择事项"
        });
        return;
      }
      let arr = Array.from(
        new Set(this.selectedOptions.map(item => item.eventMangerId))
      );
      this.ghPointLevelIdList = [];
      if (arr.length == 1) {
        this.ghPointLevelIdList = Array.from(
          new Set(this.selectedOptions.map(item => item.pointLevelId))
        );
        this.eventMangerId = arr[0];
        this.zbDialogVisible = true;
      } else {
        this.dialogVisible = true;
      }
    },
    ruleDialogAllFun() {
      if (!this.selectedOptions.length) {
        this.$message({
          type: "error",
          message: "请先选择事项"
        });
        return;
      }
      this.unionIdList = [];
      if (this.selectedOptions.length == 1) {
        this.pointOtherRulueId = this.selectedOptions[0].pointOtherRulueId;
        this.eventMangerId = this.selectedOptions[0].eventMangerId;
        this.unionIdList = [
          {
            eventMangerId: this.selectedOptions[0].eventMangerId,
            pointLevelId: this.selectedOptions[0].pointLevelId
          }
        ];
      } else {
        this.selectedOptions.forEach(item => {
          this.unionIdList.push({
            eventMangerId: item.eventMangerId,
            pointLevelId: item.pointLevelId
          });
        });
      }

      this.ruleDialogVisible = true;
    },
    ruleDialogFun(item) {
      this.pointOtherRulueId = item.pointOtherRulueId;
      this.eventMangerId = item.eventMangerId;
      this.unionIdList = [
        {
          eventMangerId: item.eventMangerId,
          pointLevelId: item.pointLevelId
        }
      ];
      this.ruleDialogVisible = true;
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.mangerPonitRelPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.mangerPonitRelPageFun();
    },

    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.mangerPonitRelPageFun();
    },
    onReset() {
      this.form.pointName = "";
      this.form.pointTypeNameId = "";
      this.form.communityCode = "";
      this.communityCode = "";
      this.form.jqDeptCode = "";
      this.form.ghEventTypeId = "";
      this.form.sxmc = "";
      this.form.state = "";
      this.form.sfyjsx = "";
      this.page.page = 1;
      this.page.size = 10;
      this.mangerPonitRelPageFun();
    },
    async creatAndChangeEventPointRelStateFun(value, item) {
      const res = await creatAndChangeEventPointRelState({
        eventMangerId: item.eventMangerId,
        eventPointRelState: value,
        pointLevelId: item.pointLevelId
      });
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.mangerPonitRelPageFun();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    // 分页查询
    async mangerPonitRelPageFun() {
      let params = {
        pointName: this.form.pointName,
        pointTypeNameId: this.form.pointTypeNameId,
        sqDeptCode: this.form.communityCode,
        jqDeptCode: this.form.jqDeptCode,
        ghEventTypeId: this.form.ghEventTypeId,
        sxmc: this.form.sxmc,
        state: this.form.state,
        sfyjsx: this.form.sfyjsx,
        page: this.page.page,
        size: this.page.size
      };
      const res = await mangerPonitRelPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.page.total = res.data.data.total;
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/point/pointEvent/index.vue